var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _g2, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPitchBearingOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2652_5773)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1021,
    cy: 12.4185,
    r: 6.72022,
    stroke: "#D98543",
    strokeWidth: 1.92006,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1013,
    cy: 5.69895,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 10.8203 19.4414)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8435,
    cy: 12.3825,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.38255,
    cy: 12.3825,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.2263,
    cy: 9.08958,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 4.94531 16.043)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9763,
    cy: 9.08958,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 16.6953 16.043)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.62473,
    cy: 6.63645,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 7.34375 18.5039)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5388,
    cy: 6.63645,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 14.2578 18.5039)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2652_5773)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1418,
    cy: 12.4504,
    r: 4.60815,
    stroke: "#D98543",
    strokeWidth: 1.53605,
    shapeRendering: "crispEdges"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1325,
    cy: 7.82395,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 10.8516 17.375)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7185,
    cy: 12.4997,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.50755,
    cy: 12.4997,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.71848,
    cy: 8.50364,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 8.4375 16.6992)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.0388,
    cy: 10.2693,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 6.75781 14.9258)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2575,
    cy: 10.2693,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 14.9766 14.9258)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.7263,
    cy: 8.57786,
    r: 0.280985,
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.280985,
    cy: 0.280985,
    r: 0.280985,
    transform: "matrix(1 0 0 -1 13.4453 16.625)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.537617
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5065 0.360222L13.8647 2.71845C14.1838 3.03746 13.9578 3.58292 13.5067 3.58292L8.79021 3.58292C8.33906 3.58292 8.11312 3.03746 8.43213 2.71845L10.7904 0.360222C10.9881 0.16246 11.3088 0.16246 11.5065 0.360222Z",
    fill: "#D98543"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6792 18.6301L18.5078 19.662C18.0788 19.8016 17.6952 19.3528 17.8998 18.9508L20.0393 14.7475C20.2439 14.3454 20.8325 14.3915 20.9721 14.8205L22.004 17.9919C22.0906 18.2578 21.9451 18.5436 21.6792 18.6301Z",
    fill: "#D98543"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.166903 17.7064L1.26592 14.5577C1.41459 14.1317 2.00404 14.0982 2.20011 14.5045L4.24984 18.7523C4.44591 19.1586 4.05284 19.5991 3.62689 19.4504L0.478139 18.3514C0.214084 18.2593 0.0747391 17.9705 0.166903 17.7064Z",
    fill: "#D98543"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2652_5773",
    x: 0.349775,
    y: 4.73828,
    width: 21.5036,
    height: 21.5036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53605
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2652_5773"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2652_5773",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2652_5773",
    x: 2.69353,
    y: 7.07422,
    width: 16.8942,
    height: 16.8981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.0721
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53605
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2652_5773"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2652_5773",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitchBearingOrange);
export default __webpack_public_path__ + "static/media/Pitch_Bearing_Orange.e08c62a2be08c046b414620937f0e81a.svg";
export { ForwardRef as ReactComponent };